import { c as _c } from "react/compiler-runtime";
import { type ForwardedRef, useImperativeHandle, useRef } from 'react';
function useForwardedRef(ref) {
  const $ = _c(1);
  const localRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => localRef.current as T;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useImperativeHandle(ref, t0);
  return localRef;
}
export default useForwardedRef;